/**
 * Tray constants
 * Shared visibility, filter, and permission constants for tray components and API utilities
 */

// Visibility

export const VISIBILITY_LABELS = {
  everyone: 'Everyone at GSD Now',
  members: 'Members only',
  me: 'Only me',
};

export const VISIBILITY_API_MAP = {
  everyone: 'everyone',
  members: 'members',
  private: 'me',
};

export const VISIBILITY_FORM_MAP = {
  everyone: 'everyone',
  members: 'members',
  me: 'private',
};

export const VISIBILITY_OPTIONS = [
  { value: 'everyone', label: VISIBILITY_LABELS.everyone },
  { value: 'members', label: VISIBILITY_LABELS.members },
  { value: 'private', label: VISIBILITY_LABELS.me },
];

export const COMMENTS_PERMISSION_OPTIONS = [
  { value: 'viewers', label: 'Everyone who can see this Tray' },
  { value: 'specific', label: 'People I give commenting access to' },
  { value: 'owner', label: 'Only me' },
];

export const MANAGER_ACCESS_OPTIONS = [
  { value: 'specific', label: 'People I give editing access to' },
  { value: 'owner', label: 'Only me' },
];

// Pagination

export const TRAYS_PER_PAGE = 50;

// Filters

export const FILTER_API_MAP = {
  'Trays I own or edit': 'owned',
  'Trays shared with me': 'shared',
};

export const FILTER_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Trays I own or edit', value: 'Trays I own or edit' },
  { label: 'Trays shared with me', value: 'Trays shared with me' },
];
